export const getRestaurantImagePath = (imageKey?: string) => {
  if (!imageKey || !process.env.RESTAURANT_IMAGE_BASE_URL) {
    return '';
  }

  return `${process.env.RESTAURANT_IMAGE_BASE_URL}/${imageKey}`;
};
